$( $ => {
  if ( !$( '.bs-div--video-card' ).length ) return;
  $( '.bs-div--video-card .video-wrapper iframe' ).attr( 'allowfullscreen', '' );
} );
